// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2UQ5p","list":"PatternAutocomplete_list__2ugRx"};